import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Sidebar } from './components/Layout/Sidebar';
import { Topbar } from './components/Layout/Topbar';
import { SubscriptionBanner } from './components/subscription/SubscriptionBanner';
import { SubscriptionGuard } from './components/subscription/SubscriptionGuard';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PublicRoute } from './components/auth/PublicRoute';
import { Dashboard } from './pages/Dashboard';
import { Patients } from './pages/Patients';
import { Plans } from './pages/Plans';
import { Schedule } from './pages/Schedule';
import { Reports } from './pages/Reports';
import { Chat } from './pages/Chat';
import { Measurements } from './pages/Measurements';
import { NutritionCalculation } from './pages/NutritionCalculation';
import { Assessment } from './pages/Assessment';
import { Resources } from './pages/Resources';
import { Subscription } from './pages/Subscription';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { SignUp } from './pages/SignUp';
import { PasswordRecovery } from './pages/PasswordRecovery';
import { VerifyEmail } from './pages/VerifyEmail';
import { NotFound } from './pages/NotFound';
import { Adherence } from './pages/Adherence';
import { LGPD } from './pages/LGPD';
import { FAQ } from './pages/FAQ';
import { TermsOfUse } from './pages/TermsOfUse';
import { Privacy } from './pages/Privacy';
import { ExamRequests } from './pages/ExamRequests';
import { Community } from './pages/Community';
import { Manipulated } from './pages/Manipulated';
import { FoodDiary } from './pages/FoodDiary';
import { NutritionInstructions } from './pages/NutritionInstructions';
import { Settings } from './pages/Settings';
import { GoogleCalendarCallback } from './pages/GoogleCalendarCallback';
import { PreConsultation } from './pages/PreConsultation';
import { VideoCall } from './pages/VideoCall';
import { LiveStream } from './pages/LiveStream';
import { LiveViewer } from './pages/LiveViewer';
import { Financial } from './pages/Financial';
import { ViewPDF } from './pages/ViewPDF';
import { ReceivedContent } from './pages/ReceivedContent';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { startNotificationMonitoring, requestNotificationPermission } from './services/notificationScheduler';
import { initializeNutritionInstructions } from './services/nutritionInstructionsService';
import './components/Layout/Layout.css';
import './components/ui/UI.css';
import './pages/Pages.css';
import './components/subscription/Subscription.css';

function AppRoutes() {
  return (
    <Routes>
      {/* Rotas públicas */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <Landing />
          </PublicRoute>
        }
      />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <SignUp />
          </PublicRoute>
        }
      />
      <Route path="/forgot-password" element={<PasswordRecovery />} />
      <Route path="/reset-password" element={<PasswordRecovery />} />
      <Route path="/verify-email" element={<PublicRoute><VerifyEmail /></PublicRoute>} />
      <Route
        path="/lgpd"
        element={
          <PublicRoute>
            <LGPD />
          </PublicRoute>
        }
      />
      <Route
        path="/faq"
        element={
          <PublicRoute>
            <FAQ />
          </PublicRoute>
        }
      />
      <Route
        path="/termos-de-uso"
        element={
          <PublicRoute>
            <TermsOfUse />
          </PublicRoute>
        }
      />
      <Route
        path="/privacidade"
        element={
          <PublicRoute>
            <Privacy />
          </PublicRoute>
        }
      />
      <Route
        path="/oauth/google/callback"
        element={
          <PublicRoute>
            <GoogleCalendarCallback />
          </PublicRoute>
        }
      />

      {/* Rotas protegidas */}
      <Route
        path="/subscription"
        element={
          <ProtectedRoute>
            <div className="ns-app-shell">
              <Sidebar />
              <Topbar />
              <main className="ns-main">
                <div className="ns-main-inner">
                  <Subscription />
                </div>
              </main>
            </div>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Dashboard />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/pacientes"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Patients />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/planos"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Plans />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/agenda"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Schedule />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/relatorios"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Reports />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/chat"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Chat />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/medicoes"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Measurements />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/calculo-nutricional"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <NutritionCalculation />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/avaliacao"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Assessment />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/recursos"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Resources />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/conteudo-recebido"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <ReceivedContent />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/adesoes"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Adherence />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/pedido-exames"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <ExamRequests />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/exames"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <ExamRequests />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/diario-alimentar"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <FoodDiary />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/instrucoes-nutricionais"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <NutritionInstructions />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/pre-consulta"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <PreConsultation />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/financeiro"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Financial />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/comunidade"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Community />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/manipulados"
        element={
          <ProtectedRoute>
            <SubscriptionGuard>
              <div className="ns-app-shell">
                <Sidebar />
                <Topbar />
                <main className="ns-main">
                  <div className="ns-main-inner">
                    <SubscriptionBanner />
                    <Manipulated />
                  </div>
                </main>
              </div>
            </SubscriptionGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/configuracoes"
        element={
          <ProtectedRoute>
            <div className="ns-app-shell">
              <Sidebar />
              <Topbar />
              <main className="ns-main">
                <div className="ns-main-inner">
                  <Settings />
                </div>
              </main>
            </div>
          </ProtectedRoute>
        }
      />

      {/* Rota catch-all para páginas não encontradas */}
      {/* Rotas de vídeo (fullscreen, sem layout) */}
      <Route
        path="/video-call"
        element={
          <ProtectedRoute>
            <VideoCall />
          </ProtectedRoute>
        }
      />
      <Route
        path="/live-stream"
        element={
          <ProtectedRoute>
            <LiveStream />
          </ProtectedRoute>
        }
      />
      <Route
        path="/live-viewer"
        element={
          <ProtectedRoute>
            <LiveViewer />
          </ProtectedRoute>
        }
      />

      <Route
        path="/pdf/:pdfId"
        element={
          <ProtectedRoute>
            <ViewPDF />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function AppContent() {
  const { user } = useAuth();
  
  useEffect(() => {
    // Inicializar bancos de dados
    initializeNutritionInstructions();
  }, []);

  useEffect(() => {
    if (user) {
      // Solicitar permissão de notificações
      requestNotificationPermission();
      
      // Iniciar monitoramento de notificações
      const stopMonitoring = startNotificationMonitoring();
      
      return () => {
        stopMonitoring();
      };
    }
  }, [user]);

  return <AppRoutes />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <SubscriptionProvider>
            <AppContent />
          </SubscriptionProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
